import axios from "./axios-handler.service";
const BASE_URL = "/api/Usuarios";

export interface Usuario {
  idUsuario: number;
  nome: string;
  slug: string;
  email: string;
  ativo: boolean;
  roles: string[];
}

export interface UsuarioNovo {
  nome: string;
  slug: string;
  email: string;
  senha: string;
  ativo: boolean;
  roles: string[];
}

export interface FiltroUsuarios {
  role: string | null;
  txtPesquisa: string;
  ativo: boolean | null;
  offset: number;
  limit: number;
  order?: string;
}

export interface SenhaNova {
  idUsuario: number;
  senhaNova: string;
}

export class UsuariosService {
  static async Lista(filtro: FiltroUsuarios): Promise<any> {
    const { role, txtPesquisa, ativo, offset, limit, order } = filtro;
    const response = await axios.get<any>(BASE_URL + "/Lista", {
      params: {
        idRole: role,
        txtPesquisa,
        ativo,
        offset,
        limit,
        order,
      },
    });
    return response.data;
  }

  static async Criar(usuarioNovo: UsuarioNovo): Promise<void> {
    await axios.post(BASE_URL + "/Criar", usuarioNovo);
  }

  static async Alterar(usuario: Usuario): Promise<void> {
    await axios.post(BASE_URL + "/Alterar", usuario);
  }

  static async Obter(idUsuario: number): Promise<Usuario> {
    const response = await axios.get(BASE_URL + "/Obter", {
      params: { idUsuario },
    });
    return response.data;
  }

  static async Excluir(idUsuario: number): Promise<void> {
    const response = await axios.post(`${BASE_URL}/Excluir`, { idUsuario });
    return response.data;
  }

  static async AlterarSenha(senha: SenhaNova): Promise<void> {
    await axios.post(BASE_URL + "/AlterarSenha", senha);
  }
}
